export default __webpack_public_path__ + "static/media/finance.5cca26bf.png";